import React, { useRef } from "react";
import styled, { css } from "styled-components";
import { useIsPortrait, useIsFullyVisible } from "@hooks";

const resolveTopBottom = ({bottom}) => bottom ? "bottom" : "top";

const debugMixin = css`
  &::before {
    display: block;
    content: "${(({$debugMessage}) => $debugMessage || "")}";
    background: ${({isStuck}) => isStuck ? "red" : "blue"};
    font-size: 10px;
    min-height: 10px;
    min-width: 10px;
  }
`;

const StickyWrapper = styled.div`
    position: ${({positionedSticky}) => positionedSticky ? "sticky" : "static"};
    z-index: 100;
    ${resolveTopBottom}: -0.1px;
    
    ${(({$debug, $debugMessage}) => ($debug || $debugMessage) && debugMixin)}
`;

const MobileSticky = React.forwardRef(({ StyledComponent, bottom, ...otherProps }, existingRef) => {
  const newRef = useRef();
  const ref = existingRef ?? newRef;
  
  const isPortrait = useIsPortrait();
  const isStuck = useIsFullyVisible(ref) && isPortrait;

  return <StickyWrapper {...otherProps} ref={ref} as={StyledComponent} positionedSticky={isPortrait} isStuck={isStuck} bottom={bottom} />;
});

export const withMobileSticky = (StyledComponent) => 
  React.forwardRef((props, ref) => <MobileSticky {...props} ref={ref} StyledComponent={StyledComponent} />);